import { LocalStorageKeys, localStorageService } from './utils/localstorageUtils'
import App from './App'
import { rootReducer } from './rootReducer'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import './assets/semantic.min.css'
import './app.less'

export const store = configureStore({
  reducer: rootReducer
})
if (localStorageService.getItem(LocalStorageKeys.IsDocClassificationEnabled.key) === null) {
  localStorageService.setItem(LocalStorageKeys.IsDocClassificationEnabled.key, false)
}
render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
)
